import { Component, OnInit } from '@angular/core';
import { TheftService } from '../../service/theft/theft.service';
import { Theft } from '../../class/theft';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { AbstractControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import { NotificationsService } from '../../../../theme/services/notifications/notifications.service';
import { config } from '../../../../../environments/config';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';



@Component({
  selector: 'app-thefts',
  templateUrl: './thefts.component.html',
  styleUrls: ['./thefts.component.scss']
})
export class TheftsComponent implements OnInit {

    public promiseForm: Promise<any>;

    public thefts: Theft[];
    public selectTheft: Theft;
    public theftID: Number = 0;
    public modNew = false;
    public modView = false;
    public openTheft = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;

    public form3: FormGroup;
    public filters: {key: string, value: string}[];
    public first = 0;

    public employeePositionToLoadPersonWhoReports: string;

    public station_id_filter: AbstractControl;
    public person_who_reports_id_filter: AbstractControl;

    public apiUrl = config.API_ROOT;

    public form4: FormGroup;

    public modExportDialog: boolean;

    public f4_date_start: AbstractControl;
    public f4_date_end: AbstractControl;

    public es: any;



    constructor(
        fb: FormBuilder,
        public theftService: TheftService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        private notificationsService: NotificationsService,
        public translate: TranslateService) {

          this.employeePositionToLoadPersonWhoReports = '2';

          this.form3 = fb.group({
            'station_id_filter': [''],
            'person_who_reports_id_filter': [''],
          });

          this.es = calendarES();

          this.station_id_filter = this.form3.controls['station_id_filter'];
          this.person_who_reports_id_filter = this.form3.controls['person_who_reports_id_filter'];

          this.form4 = fb.group({
            'f4_date_start': ['', [Validators.required]],
            'f4_date_end': ['', [Validators.required]],
        });
        this.f4_date_start = this.form4.controls['f4_date_start'];
        this.f4_date_end = this.form4.controls['f4_date_end'];

          this.modExportDialog = false;




        }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        //this.getThefts();
    }

    public loadTheftsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        this.sort = '-id';

        this.filter();
    }

    public getThefts() {
        this.theftService.getTheft(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.thefts = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
              let msg = '';
              this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                  this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                      JSON.parse(error._body).errors.forEach(element => {
                          if (element.source) {
                              if (element.source.pointer) {
                                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                      msg = msg + res3 + ', ';
                                  });
                              }
                          }
                      });
                      this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                      // this.msg.emit( { severity: 'error', summary: 'Error' } );
                  });
              });
          }
        );
    }

    public getTheftId(id) {
      this.theftService.infoTheft(id).toPromise().then(
          response => {
              this.selectTheft = response.json().data[0];
          },
          error => {
              let msg = '';
              this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                  this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                      JSON.parse(error._body).errors.forEach(element => {
                          if (element.source) {
                              if (element.source.pointer) {
                                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                      msg = msg + res3 + ', ';
                                  });
                              }
                          }
                      });
                      this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                      // this.msg.emit( { severity: 'error', summary: 'Error' } );
                  });
              });
          }
      );
    }

    printTheft(theft) {
      window.open(this.apiUrl + '/thefts/' + theft.id + '/pdf?token=' + localStorage.getItem('token'), '_blank');
    }

    public newTheft() {
        this.modNew = !this.modNew;
        this.selectTheft = null;
    }

    public cancelTheft (res) {
        this.selectTheft = null;
        this.modNew = false;
        this.modView = false;
        this.getThefts();
    }

    public showExportDialog() {
        console.log('hola');
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReportExcel(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        let url = this.apiUrl + '/thefts/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&';

        if (f4_date_start) {
            url = url + 'created_at-min=' + f4_date_start + '&';
        }

        if (f4_date_end) {
            url = url + 'created_at-max=' + f4_date_end + '&';
        }

        window.open(url, '_blank');
    }
    public edit(theft: Theft) {
        this.modNew = true;
        this.selectTheft = theft;
        this.getThefts();
    }

    public reloadTheft(id) {
      this.getTheftId(id);
    }

    public view(theft: Theft) {
        this.openTheft = true;
        this.selectTheft = theft;
        this.theftID = theft.id;
        this.modView = true;
    }

    public deleteDialog(theft: Theft) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(theft);
            }
        });
    }

    public delete(theft: Theft) {
        this.theftService.deleteTheft(theft.id).toPromise().then(
            response => {
              this.translate.get('saved').subscribe((res: string) => {
                this.notificationsService.growlNotify('success', res);
                this.getThefts();
              });
            },
            error => {
              let msg = '';
              this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                  this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                      JSON.parse(error._body).errors.forEach(element => {
                          if (element.source) {
                              if (element.source.pointer) {
                                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                      msg = msg + res3 + ', ';
                                  });
                              }
                          }
                      });
                      this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                      // this.msg.emit( { severity: 'error', summary: 'Error' } );
                  });
              });
          }
        );
    }

    public activeTheft(theft: Theft) {
        this.putTheft(theft);
    }

    public hasPermission(permission) {
      return this.hasPermissionService.hasPermission(permission);
    }

    public putTheft(values: Theft) {
        const param = {
            // 'activated': values.activated
        };
        if (values) {
            const promise = this.theftService.updateTheft(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                      this.notificationsService.growlNotify('success', res);
                    });
                },
                error => {
                  let msg = '';
                  this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                      this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                          JSON.parse(error._body).errors.forEach(element => {
                              if (element.source) {
                                  if (element.source.pointer) {
                                      this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                          msg = msg + res3 + ', ';
                                      });
                                  }
                              }
                          });
                          this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                          // this.msg.emit( { severity: 'error', summary: 'Error' } );
                      });
                  });
              }
            );
        }
    }

    public filter (values? ,pageRefresh?) {
      if (pageRefresh) {
        this.page = 1;
        this.first = 0;
        this.per_page = 10;
      }
      if (values) {
        this.filters = [];
        if (values.station_id_filter) {
          this.filters.push({'key': 'station_id-in', 'value': values.station_id_filter.id});
        }
        if (values.person_who_reports_id_filter) {
          this.filters.push({'key': 'person_who_reports_id-in', 'value': values.person_who_reports_id_filter.id});
        }
      }
      this.getThefts();
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/thefts/thefts.component.ts